export const APP_DATA_KEY = '__BM_DATA__'
export const APP_ROOT_ELEMENT_ID = 'root'
export enum AppsEnum {
  Giphy = 'giphy',
}
